module.exports = __webpack_public_path__ + "static/media/Gear.ca755f69.svg";